import { Box } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Link from '/@/components/link';
import LocalePreferences from '/@/components/locale-preferences';
import ReceiveNotificationMessages from '/@/components/receive-notification-messages';
import settings, { isExpertoBayer } from '/@/core/settings';
import { setPreferences } from '/@/store/session/actions';
import {
    getSessionCountry,
    getSessionLanguage,
    getShowReceiveNotificationMessages,
    getUser,
} from '/@/store/session/selectors';
import styles from './styles.module.css';

/** @param {typeof propTypes} props */
function AppHeader(props) {
    const country = useSelector(getSessionCountry);
    const showReceiveNotificationMessages = useSelector(getShowReceiveNotificationMessages);
    const user = useSelector(getUser);
    const language = useSelector(getSessionLanguage);
    const dispatch = useDispatch();

    function handleChange(data) {
        dispatch(setPreferences(data));
    }

    const rootClassNames = classNames(styles.root, {
        [styles.border]: props.noShadow,
        [styles.shadow]: !props.noShadow,
        [styles.showReceiveNotificationMessages]: showReceiveNotificationMessages,
    });

    return (
        <div className={rootClassNames}>
            {showReceiveNotificationMessages && <ReceiveNotificationMessages />}
            <div className={styles.content}>
                <Link to='Login' className={styles.appName}>
                    {isExpertoBayer() ? (
                        <div
                            className={classNames(styles.favicon, styles[`theme-${settings.app.theme}`])}
                            style={{
                                backgroundImage: `url('${settings.app.logo}')`,
                            }}
                        />
                    ) : (
                        <>
                            <div
                                className={classNames(styles.favicon, styles[`theme-${settings.app.theme}`])}
                                style={{ backgroundImage: `url('${settings.app.favicon}')` }}
                            />
                            <span className={styles.text}>{settings.app.name}</span>
                        </>
                    )}
                </Link>
                <Box flexGrow={1} />
                <div className={styles.right}>
                    <div className={styles.countryNoUser}>
                        {!user && (
                            <LocalePreferences
                                openUp
                                appearance='row'
                                showLabels={false}
                                country={country.id}
                                language={language}
                                onChange={handleChange}
                                showCountry
                                whiteColor
                                textColor='grey'
                                handleCountryChange={handleChange}
                                upperCase
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

const propTypes = {
    noShadow: PropTypes.bool,
};
AppHeader.propTypes = propTypes;
export default AppHeader;
